export default __webpack_public_path__ + "static/media/contest.36a97f77.png";